import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=ebdce5e8"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"
import style0 from "./Class.vue?vue&type=style&index=0&id=ebdce5e8&prod&lang=css"
import style1 from "./Class.vue?vue&type=style&index=1&id=ebdce5e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports